<script lang="ts">
  import InlineMentionBlock from "../../Mention/InlineMentionBlock.svelte";
  import { NodeViewWrapper } from "svelte-tiptap";
  import type { NodeViewProps } from "@tiptap/core";
  import { communitySlug as slug } from "$stores/community";
  import { get } from "svelte/store";
  import { memberProfilePanel } from "app/stores/memberPanel";

  export let node: NodeViewProps["node"];
  export let selected: NodeViewProps["selected"];
  export let isEditable: boolean;
  $$restProps; // prevent svelte unused props warning

  const communitySlug = get(slug);

  const { user } = node.attrs;
</script>

<NodeViewWrapper class="inline-flex">
  <InlineMentionBlock
    mentionType="members"
    item={{ title: user.handle, uuid: user.uuid, spaceType: user.spaceType }}
    {communitySlug}
    editable={isEditable || false}
    {selected}
    on:click={() => !!memberProfilePanel.clearAndShow(user.uuid, communitySlug)}
  />
</NodeViewWrapper>
